import api from 'ApiConfig';

const headhrCourseService = {
  getAllCourses: async (selectedBranch) => {
    return api.post('/headhr/get-all-course', { selectedBranch });
  },

  getBatchStructuresByCourse: async (courseId) => {
    return api.post(`/headhr/get-batch-structures-by-course/${courseId}`);
  },

  getBatchesByBatchStructure: async (batchStructureId, selectedBranch) => {
    return api.post('/headhr/get-batches-by-batch-structure', {
      batchStructureId,
      selectedBranch,
    });
  },
};

export default headhrCourseService;
